<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item>Activity Log</el-breadcrumb-item>
    </el-breadcrumb>

    <h2 class="page-title">
        {{$t('route.activity')}} 
    </h2>

    <app-activity-list :user="user"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-activity',

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/activity/activity.vue?595308fa